import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../helpers/routes";

export const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container
      className="d-flex align-items-center justify-content-center"
      style={{ height: "100vh" }}
    >
      <Row>
        <Col xs={12} md={12} lg={12}>
          <Card>
            <Card.Body className="text-center">
              <Card.Title>Estimado usuario</Card.Title>
              <Card.Text>No hemos podido encontrar tu destino</Card.Text>
              <Card.Footer className="text-center">
                <Button
                  variant="dark"
                  onClick={() => {
                    navigate(BASE_URL);
                  }}
                >
                  Volver al inicio
                </Button>
              </Card.Footer>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};
